import { render, staticRenderFns } from "./ReportCheckListHistoryRecords.vue?vue&type=template&id=2bf8a1b5&scoped=true&"
import script from "./ReportCheckListHistoryRecords.vue?vue&type=script&lang=js&"
export * from "./ReportCheckListHistoryRecords.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckListHistoryRecords.vue?vue&type=style&index=0&id=2bf8a1b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8a1b5",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
